import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-header-button',
  imports: [],
  templateUrl: './header-button.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderButtonComponent {
  label = input<string>();
  ariaLabel = input<string>();
  icon = input<boolean>(false);
  disabled = input<boolean>(false);
  colorClass = input<string>('');
  clicked = output<void>();
}
